import IssueChangeLanguageForm from './IssueChangeLanguageForm';

export default IssueChangeLanguageForm;
